import { t } from '@lingui/macro'
import { ErrorLabel } from 'app/views/common-components/forms/ErrorLabel'
import { ErrorMessage, useField } from 'formik'
import _ from 'lodash'
import React, { useEffect } from 'react'
import { myI18n } from 'translation/I18nConnectedProvider'
import { hasFieldValue } from 'utilsTS'

/**
 * Label used in form fields. Can be render in either normal or error state.
 * @category Common components
 * @subcategory Form
 * @component
 * @returns {JSX.Element}
 * @property {React.ReactNode} label Label content
 * @property {boolean} error If true, label will be render in the error state
 * @property {boolean} required If true, label will render a message informing that prociding input to this field is required
 * @property {string} id Id of the field the error is related to
 */
export const FormErrorLabel: React.FC<{
  /**
  If true, label will be render without indent
   */
  noMargin?: boolean
  /**
  /**
  If true, label will be render in the error state
   */
  error: boolean
  /**
  Non-error label content
   */
  label: React.ReactNode
  /**
  If true, label will render a message informing that prociding input to this field is required
   */
  required?: boolean
  /**
  Id of the field the error is related to
   */
  id: string
}> = ({ error, required, id, label, noMargin }) => {
  const [field, meta, helpers] = useField(id)
  const isError = error || (
    id && (meta.error && (
      meta.touched || hasFieldValue(field.value)
    ) && !Array.isArray(meta.error)))

  const message = label || (_.get(meta.error, id)
    ? (
        myI18n._(t`${_.get(meta.error, id)}`)

      )
    : null)
  const nonErrorLabel = Boolean(required || label)

  useEffect(() => {
    if (isError && !meta.touched) {
      helpers.setTouched(true)
    }
  }, [isError, meta.touched])

  return (
    <>
      {Boolean(!isError && nonErrorLabel && message != null) && (
        <p
          className='form-input-helper-text'
          style={{
            marginLeft: noMargin ? 3 : 14,
            textAlign: 'left'
          }}
        >
          {(message != null) && (
            <span>{message}</span>
          )}
        </p>
      )}
      {id && (
        <ErrorMessage name={id}>
          {(msg: React.ReactNode) => {
            if (Array.isArray(msg)) {
              return null
            }
            return (
              <div style={{ marginTop: 8 }}>
                <ErrorLabel label={msg} />
              </div>
            )
          }}
        </ErrorMessage>
      )}
    </>
  )
}
